import { createFileRoute } from "@tanstack/react-router";

import { SecuritySettingsPanel } from "../components/settings/SecuritySettings";

export const Route = createFileRoute("/settings/security")({
  component: SecuritySettingsPanel,
});
